import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const LURNS = () => {
  return <SingleContentPage title="LURNS" moduleKey="lurns" />;
};

export default LURNS;
